// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"MG","wrapper":"NG","mProduct":"OG","image":"PG","itemContainer":"QG","productName":"RG","itemDetails":"SG"};